var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabs-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card", closable: _vm.isEdit },
          on: { "tab-remove": _vm.handleTabRemove },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        _vm._l(_vm.usCustomsClearanceListFilter, function(item) {
          return _c(
            "el-tab-pane",
            {
              key: item._title,
              attrs: { label: item._title, name: item._title }
            },
            [
              _c("tab-us-customs-clearance-item", {
                ref: item._title,
                refInFor: true,
                attrs: {
                  "ams-port-list": _vm.amsPortList,
                  action: _vm.action,
                  job: _vm.job,
                  form: item,
                  "show-sync": _vm.showSync,
                  "cooperate-edit": _vm.cooperateEdit
                },
                on: {
                  chargeChange: _vm.onChargeChange,
                  clear: _vm.onClear,
                  copy: _vm.onCopy
                }
              })
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }